// Amazon UK affiliate tagging — appends `tag=<your-tag>` to any amazon.co.uk
// URL so eligible purchases earn a commission. Set
// REACT_APP_AMAZON_AFFILIATE_TAG in /app/frontend/.env once your Amazon UK
// Associates application is approved (https://affiliate-program.amazon.co.uk).
// Until then this is a no-op — links work exactly as before.

const AMAZON_TAG = process.env.REACT_APP_AMAZON_AFFILIATE_TAG || "";

/** Append the configured Amazon UK affiliate tag to an amazon.co.uk URL. */
export function tagAmazonUrl(url) {
  if (!AMAZON_TAG) return url;
  try {
    const u = new URL(url);
    if (!/(^|\.)amazon\.co\.uk$/i.test(u.hostname)) return url;
    // Don't double-tag if the caller already set one (manual override wins).
    if (!u.searchParams.has("tag")) {
      u.searchParams.set("tag", AMAZON_TAG);
    }
    return u.toString();
  } catch {
    return url;
  }
}

/** Build a tagged Amazon UK search URL for an ingredient. */
export function amazonUkSearchUrl(query) {
  return tagAmazonUrl(`https://www.amazon.co.uk/s?k=${encodeURIComponent(query)}`);
}

export const HAS_AMAZON_TAG = !!AMAZON_TAG;
